import { useState } from "react";

export default function ToPayPartial({
  order,
  setSingleOrderToPay,
  handelPaymentModal,
  formatToMMDDYYYY,
  selectedOrders,
  handleSelectOrder,
  handelCancelModal, // 👈 add this
}) {
  const [isCancelled, setIsCancelled] = useState(false);
  return (
    <>
      {" "}
      <div key={order.COI_ID} className="dp-item-wrapper">
        {/* Header Row */}
        <div className="checkbox-wrapper"></div>
        <div className="grid-image-wrapper">
          <img
            src={`${process.env.REACT_APP_BASE_URL}Assets/Products/${order.PD_ID}/${order.PD_ProductPicPath[0]}`}
            alt={order.PD_Name}
          />
        </div>
        <div className="grid-order-details-wrapper">
          <div className="ord-prod-name">
            <span className="name">{order.PD_Name}</span>
            <span className="qty">x{order.COI_Quantity}</span>
          </div>
          <span>DATE CANCELLED : {formatToMMDDYYYY(order.COI_Updated_At)}</span>
        </div>
        <div className="grid-order-status-wrapper">
          {" "}
          <span className="ord-prod-status" style={{ color: `#464646` }}>
            CANCELLED
          </span>
          <span>TOTAL AMOUNT : {order.COI_TotalAmount}</span>
        </div>
        <div className="grid-message-wrapper">
          <span style={{ color: `#464646` }}>
            Cancelled by {order.COI_CancelBy === "user" ? "you" : "admin"}.{" "}
            <br />
            REASON: {order.COI_CancelReason}
          </span>
        </div>

        <div className="grid-payment-wrapper">
          <div className="buttons-wrapper"></div>
        </div>
      </div>
    </>
  );
}
